import { ChainId } from '@donaswap/sdk'
import { NetworkAlertChains } from './ShouldShowAlert'

export const BG_COLORS_BY_DARK_MODE_AND_CHAIN_ID: {
  [isDark in 'light' | 'dark' | 'fire']: { [chainId in NetworkAlertChains]: string }
} = {
  light: {
    [ChainId.FIRECHAIN]: 'radial-gradient(circle, rgba(240, 186, 3, 0) 10%, rgba(240, 186, 3, 0.09) 60%)',
    [ChainId.RINIA]: 'radial-gradient(circle, rgba(135, 142, 149, 0) 10%, rgba(135, 142, 149, 0.09) 60%)',
    [ChainId.ETHEREUM]: 'radial-gradient(circle, rgba(98,127,235, 0) 10%, rgba(98,127,235, 0.09) 60%)',
    [ChainId.GOERLI]: 'radial-gradient(circle, rgba(98,127,235, 0) 10%, rgba(98,127,235, 0.09) 60%)',
    [ChainId.SEPOLIA]: 'radial-gradient(circle, rgba(98,127,235, 0) 10%, rgba(98,127,235, 0.09) 60%)',
    [ChainId.BSC]: 'radial-gradient(circle, rgba(240, 186, 3, 0) 10%, rgba(240, 186, 3, 0.09) 60%)',
    [ChainId.BSC_TESTNET]: 'radial-gradient(circle, rgba(240, 186, 3, 0) 10%, rgba(240, 186, 3, 0.09) 60%)',
    [ChainId.POLYGON]: 'radial-gradient(circle, rgba(130,71,229, 0) 10%, rgba(130,71,229, 0.09) 60%)',
    [ChainId.POLYGON_MUMBAI]: 'radial-gradient(circle, rgba(130,71,229, 0) 10%, rgba(130,71,229, 0.09) 60%)',
    [ChainId.POLYGON_ZKEVM]: 'radial-gradient(circle, rgba(130,71,229, 0) 10%, rgba(130,71,229, 0.09) 60%)',
    [ChainId.POLYGON_ZKEVM_TESTNET]: 'radial-gradient(circle, rgba(130,71,229, 0) 10%, rgba(130,71,229, 0.09) 60%)',
    [ChainId.CRO]: 'radial-gradient(circle, rgba(36,51,103, 0) 10%, rgba(236,51,103, 0.09) 60%)',
    [ChainId.CRO_TESTNET]: 'radial-gradient(circle, rgba(36,51,103, 0) 10%, rgba(36,51,103, 0.09) 60%)',
    [ChainId.AVALANCHE]: 'radial-gradient(circle, rgba(232,65,66, 0) 10%, rgba(232,65,66, 0.09) 60%)',
    [ChainId.AVALANCHE_FUJI]: 'radial-gradient(circle, rgba(232,65,66, 0) 10%, rgba(232,65,66, 0.09) 60%)',
    [ChainId.FANTOM_OPERA]: 'radial-gradient(circle, rgba(19,181,236, 0) 10%, rgba(19,181,236, 0.09) 60%)',
    [ChainId.FANTOM_TESTNET]: 'radial-gradient(circle, rgba(19,181,236, 0) 10%, rgba(19,181,236, 0.09) 60%)',
    [ChainId.CELO]: 'radial-gradient(circle, rgba(53,208,127, 0) 10%, rgba(53,208,127, 0.09) 60%)',
    [ChainId.CELO_ALFAJORES]: 'radial-gradient(circle, rgba(53,208,127, 0) 10%, rgba(53,208,127, 0.09) 60%)',
    [ChainId.OPTIMISM]: 'radial-gradient(circle, rgba(255,4,32, 0) 10%, rgba(255,4,32, 0.09) 60%)',
    [ChainId.OPTIMISM_GOERLI]: 'radial-gradient(circle, rgba(255,4,32, 0) 10%, rgba(255,4,32, 0.09) 60%)',
    [ChainId.ARBITRUM_ONE]: 'radial-gradient(circle, rgba(40,160,240, 0) 10%, rgba(40,160,240, 0.09) 60%)',
    [ChainId.ARBITRUM_GOERLI]: 'radial-gradient(circle, rgba(40,160,240, 0) 10%, rgba(40,160,240, 0.09) 60%)',
    [ChainId.SHIBARIUM]: 'radial-gradient(circle, rgba(255,165,2, 0) 10%, rgba(255,165,2, 0.09) 60%)',
    [ChainId.SHIBARIUM_TESTNET]: 'radial-gradient(circle, rgba(255,165,2, 0) 10%, rgba(255,165,2, 0.09) 60%)',
    [ChainId.PULSECHAIN]: 'radial-gradient(circle, rgba(124,0,255, 0) 10%, rgba(124,0,255, 0.09) 60%)',
    [ChainId.PULSECHAIN_TESTNET]: 'radial-gradient(circle, rgba(124,0,255, 0) 10%, rgba(124,0,255, 0.09) 60%)',
    [ChainId.XEN]: 'radial-gradient(circle, rgba(0,0,0, 0) 10%, rgba(0,0,0, 0.09) 60%)',
    [ChainId.XEN_DEVNET]: 'radial-gradient(circle, rgba(0,0,0, 0) 10%, rgba(0,0,0, 0.09) 60%)',
    [ChainId.HARMONY]: 'radial-gradient(circle, rgba(46,207,214, 0) 10%, rgba(46,207,214, 0.09) 60%)',
    [ChainId.HARMONY_TESTNET]: 'radial-gradient(circle, rgba(46,207,214, 0) 10%, rgba(46,207,214, 0.09) 60%)',
    [ChainId.COINEX]: 'radial-gradient(circle, rgba(78,78,255, 0) 10%, rgba(78,78,255, 0.09) 60%)',
    [ChainId.COINEX_TESTNET]: 'radial-gradient(circle, rgba(78,78,255, 0) 10%, rgba(78,78,255, 0.09) 60%)',
    [ChainId.DOGECHAIN]: 'radial-gradient(circle, rgba(146,85,250, 0) 10%, rgba(146,85,250, 0.09) 60%)',
    [ChainId.DOGECHAIN_TESTNET]: 'radial-gradient(circle, rgba(146,85,250, 0) 10%, rgba(146,85,250, 0.09) 60%)',
    [ChainId.ETHEREUM_CLASSIC]: 'radial-gradient(circle, rgba(46,132,46, 0) 10%, rgba(46,132,46, 0.09) 60%)',
    [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'radial-gradient(circle, rgba(46,132,46, 0) 10%, rgba(46,132,46, 0.09) 60%)',
    [ChainId.FUSION]: 'radial-gradient(circle, rgba(18,46,90, 0) 10%, rgba(18,46,90, 0.09) 60%)',
    [ChainId.FUSION_TESTNET]: 'radial-gradient(circle, rgba(18,46,90, 0) 10%, rgba(18,46,90, 0.09) 60%)',
    [ChainId.HECO]: 'radial-gradient(circle, rgba(49,173,88, 0) 10%, rgba(49,173,88, 0.09) 60%)',
    [ChainId.HECO_TESTNET]: 'radial-gradient(circle, rgba(49,173,88, 0) 10%, rgba(49,173,88, 0.09) 60%)',
    [ChainId.KCC]: 'radial-gradient(circle, rgba(62,230,175, 0) 10%, rgba(62,230,175, 0.09) 60%)',
    [ChainId.KCC_TESTNET]: 'radial-gradient(circle, rgba(62,230,175, 0) 10%, rgba(62,230,175, 0.09) 60%)',
    [ChainId.KLAYTN]: 'radial-gradient(circle, rgba(168,1,6, 0) 10%, rgba(168,1,6, 0.09) 60%)',
    [ChainId.KLAYTN_BAOBAB]: 'radial-gradient(circle, rgba(168,1,6, 0) 10%, rgba(168,1,6, 0.09) 60%)',
    [ChainId.OKXCHAIN]: 'radial-gradient(circle, rgba(0,0,0, 0) 10%, rgba(0,0,0, 0.09) 60%)',
    [ChainId.OKXCHAIN_TESTNET]: 'radial-gradient(circle, rgba(0,0,0, 0) 10%, rgba(0,0,0, 0.09) 60%)',
    [ChainId.THETHA]: 'radial-gradient(circle, rgba(37,185,231, 0) 10%, rgba(37,185,231, 0.09) 60%)',
    [ChainId.THETHA_TESTNET]: 'radial-gradient(circle, rgba(37,185,231, 0) 10%, rgba(37,185,231, 0.09) 60%)',
    [ChainId.ULTRON]: 'radial-gradient(circle, rgba(62,9,162, 0) 10%, rgba(62,9,162, 0.09) 60%)',
    [ChainId.ULTRON_TESTNET]: 'radial-gradient(circle, rgba(62,9,162, 0) 10%, rgba(62,9,162, 0.09) 60%)',
    [ChainId.MOONBEAM]: 'radial-gradient(circle, rgba(23,30,67, 0) 10%, rgba(23,30,67, 0.09) 60%)',
    [ChainId.MOONBASE_ALPHA]: 'radial-gradient(circle, rgba(23,30,67, 0) 10%, rgba(23,30,67, 0.09) 60%)',
    [ChainId.MOONRIVER]: 'radial-gradient(circle, rgba(243,183,5, 0) 10%, rgba(243,183,5, 0.09) 60%)',
    [ChainId.AURORA]: 'radial-gradient(circle, rgba(110,211,74, 0) 10%, rgba(110,211,74, 0.09) 60%)',
    [ChainId.AURORA_TESTNET]: 'radial-gradient(circle, rgba(110,211,74, 0) 10%, rgba(110,211,74, 0.09) 60%)',
    [ChainId.BOBA]: 'radial-gradient(circle, rgba(28,216,210, 0) 10%, rgba(28,216,210, 0.09) 60%)',
    [ChainId.BOBA_GOERLI]: 'radial-gradient(circle, rgba(28,216,210, 0) 10%, rgba(28,216,210, 0.09) 60%)',
    [ChainId.GNOSIS]: 'radial-gradient(circle, rgba(0,25,60, 0) 10%, rgba(0,25,60, 0.09) 60%)',
    [ChainId.GNOSIS_CHIADO]: 'radial-gradient(circle, rgba(0,25,60, 0) 10%, rgba(0,25,60, 0.09) 60%)',
    [ChainId.METIS]: 'radial-gradient(circle, rgba(0,207,194, 0) 10%, rgba(0,207,194, 0.09) 60%)',
    [ChainId.METIS_GOERLI]: 'radial-gradient(circle, rgba(0,207,194, 0) 10%, rgba(0,207,194, 0.09) 60%)',
    [ChainId.TELOS]: 'radial-gradient(circle, rgba(109,75,184, 0) 10%, rgba(109,75,184, 0.09) 60%)',
    [ChainId.TELOS_TESTNET]: 'radial-gradient(circle, rgba(109,75,184, 0) 10%, rgba(109,75,184, 0.09) 60%)',
    [ChainId.SYSCOIN]: 'radial-gradient(circle, rgba(31,94,255, 0) 10%, rgba(231,94,255, 0.09) 60%)',
    [ChainId.SYSCOIN_TANENBAUM]: 'radial-gradient(circle, rgba(231,94,255, 0) 10%, rgba(231,94,255, 0.09) 60%)',
    [ChainId.IOTEX]: 'radial-gradient(circle, rgba(0,212,213, 0) 10%, rgba(0,212,213, 0.09) 60%)',
    [ChainId.IOTEX_TESTNET]: 'radial-gradient(circle, rgba(0,212,213, 0) 10%, rgba(0,212,213, 0.09) 60%)',
    [ChainId.SHIDEN]: 'radial-gradient(circle, rgba(175,104,255, 0) 10%, rgba(175,104,255, 0.09) 60%)',
    [ChainId.SHIBUNYA]: 'radial-gradient(circle, rgba(175,104,255, 0) 10%, rgba(175,104,255, 0.09) 60%)',
    [ChainId.ASTAR]: 'radial-gradient(circle, rgba(0,119,238, 0) 10%, rgba(0,119,238, 0.09) 60%)',
    [ChainId.FUSE]: 'radial-gradient(circle, rgba(184,252,164, 0) 10%, rgba(184,252,164, 0.09) 60%)',
    [ChainId.FUSE_SPARKNET]: 'radial-gradient(circle, rgba(184,252,164, 0) 10%, rgba(184,252,164, 0.09) 60%)',
    [ChainId.VELAS]: 'radial-gradient(circle, rgba(0,55,193, 0) 10%, rgba(0,55,193, 0.09) 60%)',
    [ChainId.VELAS_TESTNET]: 'radial-gradient(circle, rgba(0,55,193, 0) 10%, rgba(0,55,193, 0.09) 60%)',
    [ChainId.REI]: 'radial-gradient(circle, rgba(33,22,229, 0) 10%, rgba(33,22,229, 0.09) 60%)',
    [ChainId.REI_TESTNET]: 'radial-gradient(circle, rgba(33,22,229, 0) 10%, rgba(33,22,229, 0.09) 60%)',
    [ChainId.KEKCHAIN]: 'radial-gradient(circle, rgba(24,120,60, 0) 10%, rgba(24,120,60, 0.09) 60%)',
    [ChainId.KEKCHAIN_TESTNET]: 'radial-gradient(circle, rgba(24,120,60, 0) 10%, rgba(24,120,60, 0.09) 60%)',
    [ChainId.TOMOCHAIN]: 'radial-gradient(circle, rgba(0,233,180, 0) 10%, rgba(0,233,180, 0.09) 60%)',
    [ChainId.TOMOCHAIN_TESTNET]: 'radial-gradient(circle, rgba(0,233,180, 0) 10%, rgba(0,233,180, 0.09) 60%)',
    [ChainId.THUNDERCORE]: 'radial-gradient(circle, rgba(0,214,233, 0) 10%, rgba(0,214,233, 0.09) 60%)',
    [ChainId.THUNDERCORE_TESTNET]: 'radial-gradient(circle, rgba(0,214,233, 0) 10%, rgba(0,214,233, 0.09) 60%)',
    [ChainId.WANCHAIN]: 'radial-gradient(circle, rgba(19,106,173, 0) 10%, rgba(19,106,173, 0.09) 60%)',
    [ChainId.WANCHAIN_TESTNET]: 'radial-gradient(circle, rgba(19,106,173, 0) 10%, rgba(19,106,173, 0.09) 60%)',
    [ChainId.RSK]: 'radial-gradient(circle, rgba(79,123,61, 0) 10%, rgba(79,123,61, 0.09) 60%)',
    [ChainId.RSK_TESTNET]: 'radial-gradient(circle, rgba(79,123,61, 0) 10%, rgba(79,123,61, 0.09) 60%)',
    [ChainId.ELASTOS]: 'radial-gradient(circle, rgba(42,61,88, 0) 10%, rgba(42,61,88, 0.09) 60%)',
    [ChainId.ELASTOS_TESTNET]: 'radial-gradient(circle, rgba(42,61,88, 0) 10%, rgba(42,61,88, 0.09) 60%)',
    [ChainId.CONFLUX]: 'radial-gradient(circle, rgba(31,144,155, 0) 10%, rgba(31,144,155, 0.09) 60%)',
    [ChainId.CONFLUX_TESTNET]: 'radial-gradient(circle, rgba(31,144,155, 0) 10%, rgba(31,144,155, 0.09) 60%)',
    [ChainId.BRISECHAIN]: 'radial-gradient(circle, rgba(99,12,229, 0) 10%, rgba(99,12,229, 0.09) 60%)',
    [ChainId.BRISECHAIN_TESTNET]: 'radial-gradient(circle, rgba(99,12,229, 0) 10%, rgba(99,12,229, 0.09) 60%)',
    [ChainId.MUUCHAIN]: 'radial-gradient(circle, rgba(45,63,189, 0) 10%, rgba(45,63,189, 0.09) 60%)',
    [ChainId.MUUCHAIN_TESTNET]: 'radial-gradient(circle, rgba(45,63,189, 0) 10%, rgba(45,63,189, 0.09) 60%)',
    [ChainId.CANTO]: 'radial-gradient(circle, rgba(6,252,153, 0) 10%, rgba(6,252,153, 0.09) 60%)',
    [ChainId.CANTO_TESTNET]: 'radial-gradient(circle, rgba(6,252,153, 0) 10%, rgba(6,252,153, 0.09) 60%)',
    [ChainId.OASIS_EMERALD]: 'radial-gradient(circle, rgba(0,137,219, 0) 10%, rgba(0,137,219, 0.09) 60%)',
    [ChainId.OASIS_TESTNET]: 'radial-gradient(circle, rgba(0,137,219, 0) 10%, rgba(0,137,219, 0.09) 60%)',
    [ChainId.VISION]: 'radial-gradient(circle, rgba(255, 255, 255, 0) 10%, rgba(255, 255, 255, 0.09) 60%)',
    [ChainId.VISION_TESTNET]: 'radial-gradient(circle, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0.09) 80%)',
    [ChainId.STEP]: 'radial-gradient(circle, rgba(249,213,73, 0) 10%, rgba(249,213,73, 0.09) 60%)',
    [ChainId.STEP_TESTNET]: 'radial-gradient(circle, rgba(249,213,73, 0) 10%, rgba(249,213,73, 0.09) 60%)',
    [ChainId.METER]: 'radial-gradient(circle, rgba(2,135,208, 0) 10%, rgba(2,135,208, 0.09) 60%)',
    [ChainId.METER_TESTNET]: 'radial-gradient(circle, rgba(2,135,208, 0) 10%, rgba(2,135,208, 0.09) 60%)',
    [ChainId.GODWOKEN]: 'radial-gradient(circle, rgba(0,205,158, 0) 10%, rgba(0,205,158, 0.09) 60%)',
    [ChainId.GODWOKEN_TESTNET]: 'radial-gradient(circle, rgba(0,205,158, 0) 10%, rgba(0,205,158, 0.09) 60%)',
    [ChainId.CALLISTO]: 'radial-gradient(circle, rgba(33,174,84, 0) 10%, rgba(33,174,84, 0.09) 60%)',
    [ChainId.CALLISTO_TESTNET]: 'radial-gradient(circle, rgba(33,174,84, 0) 10%, rgba(33,174,84, 0.09) 60%)',
    [ChainId.EVMOS]: 'radial-gradient(circle, rgba(237,78,51, 0) 10%, rgba(237,78,51, 0.09) 60%)',
    [ChainId.EVMOS_TESTNET]: 'radial-gradient(circle, rgba(237,78,51, 0) 10%, rgba(237,78,51, 0.09) 60%)',
    [ChainId.ENERGY_WEB_CHAIN]: 'radial-gradient(circle, rgba(165,102,255, 0) 10%, rgba(165,102,255, 0.09) 60%)',
    [ChainId.ENERGY_VOLTA]: 'radial-gradient(circle, rgba(165,102,255, 0) 10%, rgba(165,102,255, 0.09) 60%)',
    [ChainId.BASE]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.BASE_GOERLI]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.KAVA]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.KAVA_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.CLOVER]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.CLOVER_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.DEFICHAIN]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.DEFICHAIN_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.BRONOS]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.BRONOS_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.FILECOIN]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.FILECOIN_CALIBRATION]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.FLARE]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.FLARE_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.TARAXA]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.TARAXA_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.ZKSYNC]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.ZKSYNC_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
    [ChainId.LINEA_TESTNET]: 'radial-gradient(circle, rgba(0, 82, 255, 0) 10%, rgba(0, 82, 255, 0.09) 60%)',
  },
  dark: {
    [ChainId.FIRECHAIN]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.RINIA]: 'rgba(135, 142, 149, 0.19)',
    [ChainId.ETHEREUM]: 'rgba(98,127,235, 0.19)',
    [ChainId.GOERLI]: 'rgba(98,127,235, 0.19)',
    [ChainId.SEPOLIA]: 'rgba(98,127,235, 0.19)',
    [ChainId.BSC]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.BSC_TESTNET]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.POLYGON]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_MUMBAI]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM_TESTNET]: 'rgba(130,71,229, 0.19)',
    [ChainId.CRO]: 'rgba(236,51,103, 0.19)',
    [ChainId.CRO_TESTNET]: 'rgba(36,51,103, 0.19)',
    [ChainId.AVALANCHE]: 'rgba(232,65,66, 0.19)',
    [ChainId.AVALANCHE_FUJI]: 'rgba(232,65,66, 0.19)',
    [ChainId.FANTOM_OPERA]: 'rgba(19,181,236, 0.19)',
    [ChainId.FANTOM_TESTNET]: 'rgba(19,181,236, 0.19)',
    [ChainId.CELO]: 'rgba(53,208,127, 0.19)',
    [ChainId.CELO_ALFAJORES]: 'rgba(53,208,127, 0.19)',
    [ChainId.OPTIMISM]: 'rgba(255,4,32, 0.19)',
    [ChainId.OPTIMISM_GOERLI]: 'rgba(255,4,32, 0.19)',
    [ChainId.ARBITRUM_ONE]: 'rgba(40,160,240, 0.19)',
    [ChainId.ARBITRUM_GOERLI]: 'rgba(40,160,240, 0.19)',
    [ChainId.SHIBARIUM]: 'rgba(255,165,2, 0.19)',
    [ChainId.SHIBARIUM_TESTNET]: 'rgba(255,165,2, 0.19)',
    [ChainId.PULSECHAIN]: 'rgba(124,0,255, 0.19)',
    [ChainId.PULSECHAIN_TESTNET]: 'rgba(124,0,255, 0.19)',
    [ChainId.XEN]: 'rgba(0,0,0, 0.19)',
    [ChainId.XEN_DEVNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.HARMONY]: 'rgba(46,207,214, 0.19)',
    [ChainId.HARMONY_TESTNET]: 'rgba(46,207,214, 0.19)',
    [ChainId.COINEX]: 'rgba(78,78,255, 0.19)',
    [ChainId.COINEX_TESTNET]: 'rgba(78,78,255, 0.19)',
    [ChainId.DOGECHAIN]: 'rgba(146,85,250, 0.19)',
    [ChainId.DOGECHAIN_TESTNET]: 'rgba(146,85,250, 0.19)',
    [ChainId.ETHEREUM_CLASSIC]: 'rgba(46,132,46, 0.19)',
    [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'rgba(46,132,46, 0.19)',
    [ChainId.FUSION]: 'rgba(18,46,90, 0.19)',
    [ChainId.FUSION_TESTNET]: 'rgba(18,46,90, 0.19)',
    [ChainId.HECO]: 'rgba(49,173,88, 0.19)',
    [ChainId.HECO_TESTNET]: 'rgba(49,173,88, 0.19)',
    [ChainId.KCC]: 'rgba(62,230,175, 0.19)',
    [ChainId.KCC_TESTNET]: 'rgba(62,230,175, 0.19)',
    [ChainId.KLAYTN]: 'rgba(168,1,6, 0.19)',
    [ChainId.KLAYTN_BAOBAB]: 'rgba(168,1,6, 0.19)',
    [ChainId.OKXCHAIN]: 'rgba(0,0,0, 0.19)',
    [ChainId.OKXCHAIN_TESTNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.THETHA]: 'rgba(37,185,231, 0.19)',
    [ChainId.THETHA_TESTNET]: 'rgba(37,185,231, 0.19)',
    [ChainId.ULTRON]: 'rgba(62,9,162, 0.19)',
    [ChainId.ULTRON_TESTNET]: 'rgba(62,9,162, 0.19)',
    [ChainId.MOONBEAM]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONBASE_ALPHA]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONRIVER]: 'rgba(243,183,5, 0.19)',
    [ChainId.AURORA]: 'rgba(110,211,74, 0.19)',
    [ChainId.AURORA_TESTNET]: 'rgba(110,211,74, 0.19)',
    [ChainId.BOBA]: 'rgba(28,216,210, 0.19)',
    [ChainId.BOBA_GOERLI]: 'rgba(28,216,210, 0.19)',
    [ChainId.GNOSIS]: 'rgba(0,25,60, 0.19)',
    [ChainId.GNOSIS_CHIADO]: 'rgba(0,25,60, 0.19)',
    [ChainId.METIS]: 'rgba(0,207,194, 0.19)',
    [ChainId.METIS_GOERLI]: 'rgba(0,207,194, 0.19)',
    [ChainId.TELOS]: 'rgba(109,75,184, 0.19)',
    [ChainId.TELOS_TESTNET]: 'rgba(109,75,184, 0.19)',
    [ChainId.SYSCOIN]: 'rgba(231,94,255, 0.19)',
    [ChainId.SYSCOIN_TANENBAUM]: 'rgba(231,94,255, 0.19)',
    [ChainId.IOTEX]: 'rgba(0,212,213, 0.19)',
    [ChainId.IOTEX_TESTNET]: 'rgba(0,212,213, 0.19)',
    [ChainId.SHIDEN]: 'rgba(175,104,255, 0.19)',
    [ChainId.SHIBUNYA]: 'rgba(175,104,255, 0.19)',
    [ChainId.ASTAR]: 'rgba(0,119,238, 0.19)',
    [ChainId.FUSE]: 'rgba(184,252,164, 0.19)',
    [ChainId.FUSE_SPARKNET]: 'rgba(184,252,164, 0.19)',
    [ChainId.VELAS]: 'rgba(0,55,193, 0.19)',
    [ChainId.VELAS_TESTNET]: 'rgba(0,55,193, 0.19)',
    [ChainId.REI]: 'rgba(33,22,229, 0.19)',
    [ChainId.REI_TESTNET]: 'rgba(33,22,229, 0.19)',
    [ChainId.KEKCHAIN]: 'rgba(24,120,60, 0.19)',
    [ChainId.KEKCHAIN_TESTNET]: 'rgba(24,120,60, 0.19)',
    [ChainId.TOMOCHAIN]: 'rgba(0,233,180, 0.19)',
    [ChainId.TOMOCHAIN_TESTNET]: 'rgba(0,233,180, 0.19)',
    [ChainId.THUNDERCORE]: 'rgba(0,214,233, 0.19)',
    [ChainId.THUNDERCORE_TESTNET]: 'rgba(0,214,233, 0.19)',
    [ChainId.WANCHAIN]: 'rgba(19,106,173, 0.19)',
    [ChainId.WANCHAIN_TESTNET]: 'rgba(19,106,173, 0.19)',
    [ChainId.RSK]: 'rgba(79,123,61, 0.19)',
    [ChainId.RSK_TESTNET]: 'rgba(79,123,61, 0.19)',
    [ChainId.ELASTOS]: 'rgba(42,61,88, 0.19)',
    [ChainId.ELASTOS_TESTNET]: 'rgba(42,61,88, 0.19)',
    [ChainId.CONFLUX]: 'rgba(31,144,155, 0.19)',
    [ChainId.CONFLUX_TESTNET]: 'rgba(31,144,155, 0.19)',
    [ChainId.BRISECHAIN]: 'rgba(99,12,229, 0.19)',
    [ChainId.BRISECHAIN_TESTNET]: 'rgba(99,12,229, 0.19)',
    [ChainId.MUUCHAIN]: 'rgba(45,63,189, 0.19)',
    [ChainId.MUUCHAIN_TESTNET]: 'rgba(45,63,189, 0.19)',
    [ChainId.CANTO]: 'rgba(6,252,153, 0.19)',
    [ChainId.CANTO_TESTNET]: 'rgba(6,252,153, 0.19)',
    [ChainId.OASIS_EMERALD]: 'rgba(0,137,219, 0.19)',
    [ChainId.OASIS_TESTNET]: 'rgba(0,137,219, 0.19)',
    [ChainId.VISION]: 'rgba(255, 255, 255, 0.19)',
    [ChainId.VISION_TESTNET]: 'rgba(0, 0, 0, 0.19) 80%)',
    [ChainId.STEP]: 'rgba(249,213,73, 0.19)',
    [ChainId.STEP_TESTNET]: 'rgba(249,213,73, 0.19)',
    [ChainId.METER]: 'rgba(2,135,208, 0.19)',
    [ChainId.METER_TESTNET]: 'rgba(2,135,208, 0.19)',
    [ChainId.GODWOKEN]: 'rgba(0,205,158, 0.19)',
    [ChainId.GODWOKEN_TESTNET]: 'rgba(0,205,158, 0.19)',
    [ChainId.CALLISTO]: 'rgba(33,174,84, 0.19)',
    [ChainId.CALLISTO_TESTNET]: 'rgba(33,174,84, 0.19)',
    [ChainId.EVMOS]: 'rgba(237,78,51, 0.19)',
    [ChainId.EVMOS_TESTNET]: 'rgba(237,78,51, 0.19)',
    [ChainId.ENERGY_WEB_CHAIN]: 'rgba(165,102,255, 0.19)',
    [ChainId.ENERGY_VOLTA]: 'rgba(165,102,255, 0.19)',
    [ChainId.BASE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BASE_GOERLI]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN_CALIBRATION]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.LINEA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
  },
  fire: {
    [ChainId.FIRECHAIN]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.RINIA]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.ETHEREUM]: 'rgba(98,127,235, 0.19)',
    [ChainId.GOERLI]: 'rgba(98,127,235, 0.19)',
    [ChainId.SEPOLIA]: 'rgba(98,127,235, 0.19)',
    [ChainId.BSC]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.BSC_TESTNET]: 'rgba(240, 186, 3, 0.19)',
    [ChainId.POLYGON]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_MUMBAI]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM]: 'rgba(130,71,229, 0.19)',
    [ChainId.POLYGON_ZKEVM_TESTNET]: 'rgba(130,71,229, 0.19)',
    [ChainId.CRO]: 'rgba(236,51,103, 0.19)',
    [ChainId.CRO_TESTNET]: 'rgba(36,51,103, 0.19)',
    [ChainId.AVALANCHE]: 'rgba(232,65,66, 0.19)',
    [ChainId.AVALANCHE_FUJI]: 'rgba(232,65,66, 0.19)',
    [ChainId.FANTOM_OPERA]: 'rgba(19,181,236, 0.19)',
    [ChainId.FANTOM_TESTNET]: 'rgba(19,181,236, 0.19)',
    [ChainId.CELO]: 'rgba(53,208,127, 0.19)',
    [ChainId.CELO_ALFAJORES]: 'rgba(53,208,127, 0.19)',
    [ChainId.OPTIMISM]: 'rgba(255,4,32, 0.19)',
    [ChainId.OPTIMISM_GOERLI]: 'rgba(255,4,32, 0.19)',
    [ChainId.ARBITRUM_ONE]: 'rgba(40,160,240, 0.19)',
    [ChainId.ARBITRUM_GOERLI]: 'rgba(40,160,240, 0.19)',
    [ChainId.SHIBARIUM]: 'rgba(255,165,2, 0.19)',
    [ChainId.SHIBARIUM_TESTNET]: 'rgba(255,165,2, 0.19)',
    [ChainId.PULSECHAIN]: 'rgba(124,0,255, 0.19)',
    [ChainId.PULSECHAIN_TESTNET]: 'rgba(124,0,255, 0.19)',
    [ChainId.XEN]: 'rgba(0,0,0, 0.19)',
    [ChainId.XEN_DEVNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.HARMONY]: 'rgba(46,207,214, 0.19)',
    [ChainId.HARMONY_TESTNET]: 'rgba(46,207,214, 0.19)',
    [ChainId.COINEX]: 'rgba(78,78,255, 0.19)',
    [ChainId.COINEX_TESTNET]: 'rgba(78,78,255, 0.19)',
    [ChainId.DOGECHAIN]: 'rgba(146,85,250, 0.19)',
    [ChainId.DOGECHAIN_TESTNET]: 'rgba(146,85,250, 0.19)',
    [ChainId.ETHEREUM_CLASSIC]: 'rgba(46,132,46, 0.19)',
    [ChainId.ETHEREUM_CLASSIC_TESTNET]: 'rgba(46,132,46, 0.19)',
    [ChainId.FUSION]: 'rgba(18,46,90, 0.19)',
    [ChainId.FUSION_TESTNET]: 'rgba(18,46,90, 0.19)',
    [ChainId.HECO]: 'rgba(49,173,88, 0.19)',
    [ChainId.HECO_TESTNET]: 'rgba(49,173,88, 0.19)',
    [ChainId.KCC]: 'rgba(62,230,175, 0.19)',
    [ChainId.KCC_TESTNET]: 'rgba(62,230,175, 0.19)',
    [ChainId.KLAYTN]: 'rgba(168,1,6, 0.19)',
    [ChainId.KLAYTN_BAOBAB]: 'rgba(168,1,6, 0.19)',
    [ChainId.OKXCHAIN]: 'rgba(0,0,0, 0.19)',
    [ChainId.OKXCHAIN_TESTNET]: 'rgba(0,0,0, 0.19)',
    [ChainId.THETHA]: 'rgba(37,185,231, 0.19)',
    [ChainId.THETHA_TESTNET]: 'rgba(37,185,231, 0.19)',
    [ChainId.ULTRON]: 'rgba(62,9,162, 0.19)',
    [ChainId.ULTRON_TESTNET]: 'rgba(62,9,162, 0.19)',
    [ChainId.MOONBEAM]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONBASE_ALPHA]: 'rgba(23,30,67, 0.19)',
    [ChainId.MOONRIVER]: 'rgba(243,183,5, 0.19)',
    [ChainId.AURORA]: 'rgba(110,211,74, 0.19)',
    [ChainId.AURORA_TESTNET]: 'rgba(110,211,74, 0.19)',
    [ChainId.BOBA]: 'rgba(28,216,210, 0.19)',
    [ChainId.BOBA_GOERLI]: 'rgba(28,216,210, 0.19)',
    [ChainId.GNOSIS]: 'rgba(0,25,60, 0.19)',
    [ChainId.GNOSIS_CHIADO]: 'rgba(0,25,60, 0.19)',
    [ChainId.METIS]: 'rgba(0,207,194, 0.19)',
    [ChainId.METIS_GOERLI]: 'rgba(0,207,194, 0.19)',
    [ChainId.TELOS]: 'rgba(109,75,184, 0.19)',
    [ChainId.TELOS_TESTNET]: 'rgba(109,75,184, 0.19)',
    [ChainId.SYSCOIN]: 'rgba(231,94,255, 0.19)',
    [ChainId.SYSCOIN_TANENBAUM]: 'rgba(231,94,255, 0.19)',
    [ChainId.IOTEX]: 'rgba(0,212,213, 0.19)',
    [ChainId.IOTEX_TESTNET]: 'rgba(0,212,213, 0.19)',
    [ChainId.SHIDEN]: 'rgba(175,104,255, 0.19)',
    [ChainId.SHIBUNYA]: 'rgba(175,104,255, 0.19)',
    [ChainId.ASTAR]: 'rgba(0,119,238, 0.19)',
    [ChainId.FUSE]: 'rgba(184,252,164, 0.19)',
    [ChainId.FUSE_SPARKNET]: 'rgba(184,252,164, 0.19)',
    [ChainId.VELAS]: 'rgba(0,55,193, 0.19)',
    [ChainId.VELAS_TESTNET]: 'rgba(0,55,193, 0.19)',
    [ChainId.REI]: 'rgba(33,22,229, 0.19)',
    [ChainId.REI_TESTNET]: 'rgba(33,22,229, 0.19)',
    [ChainId.KEKCHAIN]: 'rgba(24,120,60, 0.19)',
    [ChainId.KEKCHAIN_TESTNET]: 'rgba(24,120,60, 0.19)',
    [ChainId.TOMOCHAIN]: 'rgba(0,233,180, 0.19)',
    [ChainId.TOMOCHAIN_TESTNET]: 'rgba(0,233,180, 0.19)',
    [ChainId.THUNDERCORE]: 'rgba(0,214,233, 0.19)',
    [ChainId.THUNDERCORE_TESTNET]: 'rgba(0,214,233, 0.19)',
    [ChainId.WANCHAIN]: 'rgba(19,106,173, 0.19)',
    [ChainId.WANCHAIN_TESTNET]: 'rgba(19,106,173, 0.19)',
    [ChainId.RSK]: 'rgba(79,123,61, 0.19)',
    [ChainId.RSK_TESTNET]: 'rgba(79,123,61, 0.19)',
    [ChainId.ELASTOS]: 'rgba(42,61,88, 0.19)',
    [ChainId.ELASTOS_TESTNET]: 'rgba(42,61,88, 0.19)',
    [ChainId.CONFLUX]: 'rgba(31,144,155, 0.19)',
    [ChainId.CONFLUX_TESTNET]: 'rgba(31,144,155, 0.19)',
    [ChainId.BRISECHAIN]: 'rgba(99,12,229, 0.19)',
    [ChainId.BRISECHAIN_TESTNET]: 'rgba(99,12,229, 0.19)',
    [ChainId.MUUCHAIN]: 'rgba(45,63,189, 0.19)',
    [ChainId.MUUCHAIN_TESTNET]: 'rgba(45,63,189, 0.19)',
    [ChainId.CANTO]: 'rgba(6,252,153, 0.19)',
    [ChainId.CANTO_TESTNET]: 'rgba(6,252,153, 0.19)',
    [ChainId.OASIS_EMERALD]: 'rgba(0,137,219, 0.19)',
    [ChainId.OASIS_TESTNET]: 'rgba(0,137,219, 0.19)',
    [ChainId.VISION]: 'rgba(255, 255, 255, 0.19)',
    [ChainId.VISION_TESTNET]: 'rgba(0, 0, 0, 0.19) 80%)',
    [ChainId.STEP]: 'rgba(249,213,73, 0.19)',
    [ChainId.STEP_TESTNET]: 'rgba(249,213,73, 0.19)',
    [ChainId.METER]: 'rgba(2,135,208, 0.19)',
    [ChainId.METER_TESTNET]: 'rgba(2,135,208, 0.19)',
    [ChainId.GODWOKEN]: 'rgba(0,205,158, 0.19)',
    [ChainId.GODWOKEN_TESTNET]: 'rgba(0,205,158, 0.19)',
    [ChainId.CALLISTO]: 'rgba(33,174,84, 0.19)',
    [ChainId.CALLISTO_TESTNET]: 'rgba(33,174,84, 0.19)',
    [ChainId.EVMOS]: 'rgba(237,78,51, 0.19)',
    [ChainId.EVMOS_TESTNET]: 'rgba(237,78,51, 0.19)',
    [ChainId.ENERGY_WEB_CHAIN]: 'rgba(165,102,255, 0.19)',
    [ChainId.ENERGY_VOLTA]: 'rgba(165,102,255, 0.19)',
    [ChainId.BASE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BASE_GOERLI]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.KAVA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.CLOVER_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.DEFICHAIN_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.BRONOS_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FILECOIN_CALIBRATION]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.FLARE_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.TARAXA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.ZKSYNC_TESTNET]: 'rgba(0, 82, 255, 0.19)',
    [ChainId.LINEA_TESTNET]: 'rgba(0, 82, 255, 0.19)',
  },
}
